
import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'app-state-button',
    templateUrl: './state-button.component.html',
    styleUrls: ['./state-button.component.scss'],
    standalone: false
})
export class StateButtonComponent implements OnInit {

	@Input()
	public buttonClass: any;

	@Input()
	public buttonStyle: any;

	@Output()
	public activeChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	private _active: boolean;
	public get active(): boolean {
		return this._active;
	}
	@Input()
	public set active(value: boolean) {
		this._active = value;

		this.activeChange.emit(this._active);
	}

	@Output()
	public onClick: EventEmitter<Event> = new EventEmitter<Event>();

	constructor() {}

	ngOnInit(): void {
	}
}
